import { useEffect, memo } from 'react'
import { connect } from 'react-redux'

// Actions
import { actions as cmsActions } from 'modules/cms/actions'

// Components
import { Hero } from 'kit'
import { Pill, Link } from '@tracklib/kit'

// Types
import { CmsPage, CmsPageCategory, State } from 'types'

import styles from './heroarticleblock.css'

const renderCategories = (categories: Array<CmsPageCategory>) =>
  categories.map(x => (
    <span key={x.id} className={styles.category}>
      {x.name}
    </span>
  ))

type HeroArticleBlockProps = {
  value: {
    hero_articles: Array<{
      article: number
      image: number
      image_mobile: number
      title: string
      title_max_length: string
      body: string
      button_text: string
      hide_info: boolean
    }>
  }
  // mapStateToProps
  article: CmsPage
  // mapDispatchToProps
  fetchArticlesByIds: (arg0: Array<number>) => void
}

const HeroArticleBlock = ({ fetchArticlesByIds, value: { hero_articles }, article }: HeroArticleBlockProps): JSX.Element => {
  const cmsArticle = hero_articles[0]
  useEffect(() => {
    fetchArticlesByIds([cmsArticle.article])
  }, [cmsArticle.article, fetchArticlesByIds])

  if (!article) {
    return <Hero />
  }
  const title = cmsArticle.title || article.title
  const titleMaxLength = cmsArticle.title_max_length || (article.title_max_length ? +article.title_max_length : undefined)
  const image = cmsArticle.image || article.image.id
  const mobileImageOverride = cmsArticle.image_mobile || (article.mobile_override_image || {}).id
  const summary = cmsArticle.body || article.summary
  const { categories } = article
  const permalink = `/blog/${article.meta.slug}`
  const hideInfo = cmsArticle.hide_info
  return (
    <Link to={permalink} data-name="article-link">
      <Hero image={image} mobileImageOverride={mobileImageOverride} marginBottom={0} gradient>
        {article && (
          <div>
            {!hideInfo && <Pill type="opaque">{renderCategories(categories)}</Pill>}
            <Hero.Title maxLength={titleMaxLength}>{title}</Hero.Title>
            {summary && <Hero.Description>{summary}</Hero.Description>}
            <Hero.Button>{cmsArticle.button_text || 'Read article'}</Hero.Button>
          </div>
        )}
      </Hero>
    </Link>
  )
}

const mapStateToProps = (state: State, { value: { hero_articles } }: HeroArticleBlockProps): JSX.Element => {
  return {
    article: state.entities.pages[String(hero_articles[0].article)],
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchArticlesByIds: (articleIds: Array<number>) => dispatch(cmsActions.fetchArticlesByIds(articleIds)),
  }
}

export default memo<HeroArticleBlockProps>(connect(mapStateToProps, mapDispatchToProps)(HeroArticleBlock))
